import React from 'react';
const CHECKOUT_URL = 'https://pay.hotmart.com/N106344754R?off=9fw6qwmk';
interface CtaButtonProps {
  size?: 'default' | 'large';
  className?: string;
}
export function CtaButton({
  size = 'default',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-8 py-5 text-lg sm:text-xl tracking-wide' : 'px-8 py-4 text-base sm:text-lg tracking-wide';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group relative inline-flex w-full items-center justify-center rounded-full font-semibold uppercase text-[#1A1014] transition-transform duration-300 ease-out hover:scale-[1.03] focus-visible:scale-[1.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A24B]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-[#3B0A1E] ${sizing} ${className}`} style={{
    backgroundImage: 'linear-gradient(135deg, #E8C877 0%, #C9A24B 45%, #A87F2E 100%)',
    boxShadow: '0 10px 40px -8px rgba(201, 162, 75, 0.55)'
  }} data-id="element-5">
      {/* Diffuse gold glow behind the button */}
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-70 group-focus-visible:opacity-70" style={{
      background: 'radial-gradient(closest-side, rgba(201,162,75,0.9), transparent)'
    }} data-id="element-6" />
      <span className="relative" data-id="element-7">QUIERO ACCEDER AHORA</span>
    </a>;
}
export { CHECKOUT_URL };